/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdnRouterHelperApi} from './state-utils';
import { adTagStates } from './../ad-tag/ad-tag.states';
import { adUnitStates } from './../ad-unit/ad-unit.states';
import { adminStates } from './../admin/admin.states';
import { apiKeyStates } from './../admin/api-key/api-key.states';
import { cdnUploadStates } from './../admin/cdn-upload/cdn-upload.states';
import { contextServiceConfigurationStates } from './../admin/context-service-configuration/context-service-configuration.states';
import { couponStates } from './../admin/coupon/coupon.states';
import { customEventStates } from './../admin/custom-event/custom-event.states';
import { dataExportStates } from './../admin/data-export/data-export.states';
import { emailTemplateStates } from './../admin/email-template/email-template.states';
import { emailTranslationStates } from './../admin/email-translation/email-translation.states';
import { externalDemandSourceStates } from './../admin/external-demand-source/external-demand-source.states';
import { layoutStates } from './../admin/layout/layout.states';
import { layoutExampleStates } from './../admin/layout-example/layout-example.states';
import { layoutIncludeStates } from './../admin/layout-include/layout-include.states';
import { marketplaceProductStates } from './../admin/marketplace-product/marketplace-product.states';
import { networkStates } from './../admin/network/network.states';
import { notificationPreferencesStates } from './../admin/notification-preferences/notification-preferences.states';
import { productStates } from './../admin/product/product.states';
import { referenceDataStates } from './../admin/reference-data/reference-data.states';
import { roleStates } from './../admin/role/role.states';
import { teamStates } from './../admin/team/team.states';
import { teamGroupStates } from './../admin/team-group/team-group.states';
import { tierStates } from './../admin/tier/tier.states';
import { userStates } from './../admin/user/user.states';
import { userProfileStates } from './../admin/user-profile/user-profile.states';
import { advertiserStates } from './../advertiser/advertiser.states';
import { baseStates } from './../base/base.states';
import { nudeStates } from './../base/nude/nude.states';
import { previewStates } from './../base/nude/preview.states';
import { sectionsStates } from './../base/sections.states';
import { simpleStates } from './../base/simple/simple.states';
import { blocklistStates } from './../blocklist/blocklist.states';
import { bookingCalendarStates } from './../booking-calendar/booking-calendar.states';
import { axLineItemStates } from './../campaign/ax-line-item.states';
import { campaignStates } from './../campaign/campaign.states';
import { creativeStates } from './../creative/creative.states';
import { creativeSetStates } from './../creative-set/creative-set.states';
import { dataQueriesStates } from './../data-queries/data-queries.states';
import { earningsAccountStates } from './../earnings-account/earnings-account.states';
import { errorStates } from './../errors/error.states';
import { externalAdUnitStates } from './../external-ad-unit/external-ad-unit.states';
import { fieldsStates } from './../fields/fields.states';
import { folderStates } from './../folder/folder.states';
import { folioStates } from './../folio/folio.states';
import { homeStates } from './../home/home.states';
import { invoiceTranslationStates } from './../invoice-translation/invoice-translation.states';
import { libraryCreativeStates } from './../library-creative/library-creative.states';
import { lineItemStates } from './../line-item/line-item.states';
import { lineItemTemplateStates } from './../line-item/line-item-template.states';
import { mappingStates } from './../mapping/mapping.states';
import { orderStates } from './../order/order.states';
import { paymentStates } from './../payment/payment.states';
import { politicalCampaignStates } from './../political-campaign/political-campaign.states';
import { politicalEntityStates } from './../political-entity/political-entity.states';
import { printLineItemStates } from './../print-line-item/print-line-item.states';
import { reachAnalysisStates } from './../reach-analysis/reach-analysis.states';
import { queryStates } from './../report/query/query.states';
import { reportStates } from './../report/report.states';
import { reportScheduleStates } from './../report-schedule/report-schedule.states';
import { reportTemplatesStates } from './../report-template/report-templates.states';
import { reportTranslationStates } from './../report-translation/report-translation.states';
import { retailProductStates } from './../retail-product/retail-product.states';
import { axReviewStates } from './../review/ax-review.states';
import { reviewStates } from './../review/review.states';
import { rulesetStates } from './../ruleset/ruleset.states';
import { searchStates } from './../search/search.states';
import { segmentStates } from './../segment/segment.states';
import { signInStates } from './../sign-in/sign-in.states';
import { siteStates } from './../site/site.states';
import { siteGroupStates } from './../site-group/site-group.states';
import { thirdPartyAudienceStates } from './../third-party-audience/third-party-audience.states';
import { triggerStates } from './../trigger/trigger.states';
import { workspaceStates } from './../workspace/workspace.states';

export function buildFeatureStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return [
  ...adTagStates(adnRouterHelper),
  ...adUnitStates(adnRouterHelper),
  ...adminStates(adnRouterHelper),
  ...apiKeyStates(adnRouterHelper),
  ...cdnUploadStates(adnRouterHelper),
  ...contextServiceConfigurationStates(adnRouterHelper),
  ...couponStates(adnRouterHelper),
  ...customEventStates(adnRouterHelper),
  ...dataExportStates(adnRouterHelper),
  ...emailTemplateStates(adnRouterHelper),
  ...emailTranslationStates(adnRouterHelper),
  ...externalDemandSourceStates(adnRouterHelper),
  ...layoutStates(adnRouterHelper),
  ...layoutExampleStates(adnRouterHelper),
  ...layoutIncludeStates(adnRouterHelper),
  ...marketplaceProductStates(adnRouterHelper),
  ...networkStates(adnRouterHelper),
  ...notificationPreferencesStates(adnRouterHelper),
  ...productStates(adnRouterHelper),
  ...referenceDataStates(adnRouterHelper),
  ...roleStates(adnRouterHelper),
  ...teamStates(adnRouterHelper),
  ...teamGroupStates(adnRouterHelper),
  ...tierStates(adnRouterHelper),
  ...userStates(adnRouterHelper),
  ...userProfileStates(adnRouterHelper),
  ...advertiserStates(adnRouterHelper),
  ...baseStates(adnRouterHelper),
  ...nudeStates(adnRouterHelper),
  ...previewStates(adnRouterHelper),
  ...sectionsStates(adnRouterHelper),
  ...simpleStates(adnRouterHelper),
  ...blocklistStates(adnRouterHelper),
  ...bookingCalendarStates(adnRouterHelper),
  ...axLineItemStates(adnRouterHelper),
  ...campaignStates(adnRouterHelper),
  ...creativeStates(adnRouterHelper),
  ...creativeSetStates(adnRouterHelper),
  ...dataQueriesStates(adnRouterHelper),
  ...earningsAccountStates(adnRouterHelper),
  ...errorStates(adnRouterHelper),
  ...externalAdUnitStates(adnRouterHelper),
  ...fieldsStates(adnRouterHelper),
  ...folderStates(adnRouterHelper),
  ...folioStates(adnRouterHelper),
  ...homeStates(adnRouterHelper),
  ...invoiceTranslationStates(adnRouterHelper),
  ...libraryCreativeStates(adnRouterHelper),
  ...lineItemStates(adnRouterHelper),
  ...lineItemTemplateStates(adnRouterHelper),
  ...mappingStates(adnRouterHelper),
  ...orderStates(adnRouterHelper),
  ...paymentStates(adnRouterHelper),
  ...politicalCampaignStates(adnRouterHelper),
  ...politicalEntityStates(adnRouterHelper),
  ...printLineItemStates(adnRouterHelper),
  ...reachAnalysisStates(adnRouterHelper),
  ...queryStates(adnRouterHelper),
  ...reportStates(adnRouterHelper),
  ...reportScheduleStates(adnRouterHelper),
  ...reportTemplatesStates(adnRouterHelper),
  ...reportTranslationStates(adnRouterHelper),
  ...retailProductStates(adnRouterHelper),
  ...axReviewStates(adnRouterHelper),
  ...reviewStates(adnRouterHelper),
  ...rulesetStates(adnRouterHelper),
  ...searchStates(adnRouterHelper),
  ...segmentStates(adnRouterHelper),
  ...signInStates(adnRouterHelper),
  ...siteStates(adnRouterHelper),
  ...siteGroupStates(adnRouterHelper),
  ...thirdPartyAudienceStates(adnRouterHelper),
  ...triggerStates(adnRouterHelper),
  ...workspaceStates(adnRouterHelper),
  ];
}
